import {Constants, MOOD_TYPE_NAME_RECORD} from '../../constants';
import {MoodLight, MoodType} from '../types';

export const isAdvancedMoodLight = (moodLight: MoodLight) => {
  return Constants.ADVANCED_MOOD_TYPES.some(
    advancedMoodType =>
      advancedMoodType ===
      MOOD_TYPE_NAME_RECORD[moodLight.projector.meta.moodType as MoodType],
  );
};
